import { Box } from "@material-ui/core";
import * as S from "./styles";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { IsaPText } from "../IsaPText/IsaPText";
import { formatMoney } from "../../validators/formatMoney";
export function TaxShipping({ tax }: { tax: number }) {
  return (
    <S.Box data-test="freeShipping">
      <MonetizationOnOutlinedIcon fontSize="large" sx={{ color: "#004474" }} />
      <Box>
        <IsaPText color="#004474" textAlign="start" fontWeight="700">
          Serviço de coleta
        </IsaPText>
        <IsaPText color="#666666" textAlign="start" fontSize="14px">
          R${tax ? formatMoney(tax) : "0,00"}
        </IsaPText>
      </Box>
    </S.Box>
  );
}
